module.exports = __webpack_public_path__ + "img/service_fw.2bceeea7.jpg";